const types = {
  ADD_MESSAGE: 'message/set',
  CLEAR_MESSAGE: 'message/clear',
  SET_LOADING_STATE: 'message/set-loading',
  SET_AUTH: 'auth-state/set',
  SET_USER: 'user/set',
  SET_LOGOUT: 'user/logout',
  SET_ALL_USERS: 'all-users/set',
  SET_USER_BY_ID: 'all-users/set-user-by-id',
  SET_OBJECT: 'objects/set',
  ADD_OBJECT: 'objects/add',
  UPDATE_OBJECT: 'objects/update',
  DELETE_OBJECT: 'objects/delete',
  SET_PARTNER: 'partners/set',
  ADD_PARTNER: 'partners/add',
  UPDATE_PARTNER: 'partners/update',
  DELETE_PARTNER: 'partners/delete',
  SET_CAREER: 'career/set',
  ADD_CAREER: 'career/add',
  UPDATE_CAREER: 'career/update',
  DELETE_CAREER: 'career/delete',
};

export default types;
